import { useTranslation } from "react-i18next";
import { IconButton, InputAdornment, TextField } from "@mzc-pdc/ui";
import { IconCancelCircle, IconSearchCircle } from "@mzc-cloudplex/icons";
import theme from "@styles/theme";

const TreeSearchBar = ({ onHandleTreeFilter, onChangeSearchValue, onClickResetTreeFilter, name, ...others }) => {
    const { t } = useTranslation();

    return (
        <>
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    onHandleTreeFilter();
                }}
            >
                <TextField
                    fullWidth
                    className={"area-search"}
                    color={"primary"}
                    variant={"standard"}
                    size={"medium"}
                    onChange={(e) => {
                        onChangeSearchValue(e.target.value);
                    }}
                    value={others.search}
                    placeholder={t(`common::label::{{name}} Search`, {
                        name: name,
                    })}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                {others.search && (
                                    <IconButton
                                        circled
                                        onClick={(e) => {
                                            e.preventDefault();
                                            onClickResetTreeFilter();
                                        }}
                                    >
                                        <IconCancelCircle size={12} htmlColor={theme.palette.greySecondary[500]} />
                                    </IconButton>
                                )}
                                <IconButton circled onClick={() => onHandleTreeFilter()}>
                                    <IconSearchCircle size={20} color={"greySecondary"} />
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                    inputProps={{
                        sx: {
                            padding: `13.95px 12px`,
                        },
                    }}
                />
            </form>
        </>
    );
};

export default TreeSearchBar;
